"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeTimezone = exports.removeTimeAndTimezone = exports.isDateOlderThanToday = exports.formatDateTo = void 0;
var _dateFns = require("date-fns");
/**
 * Checks if the date provided as an argument is minor than current date
 * @param {string} date - string which contains date
 */
var isDateOlderThanToday = function isDateOlderThanToday(date) {
  var today = new Date();
  var event = new Date(date || 0);
  return (0, _dateFns.isBefore)(event, today);
};
/**
 * Returns Date with client timezone and not taking in account current date timezone
 * @param {string} date - string which contains date with or without timezone
 */
exports.isDateOlderThanToday = isDateOlderThanToday;
var removeTimezone = function removeTimezone(date) {
  if (!date) return new Date();

  // Try to create a date without timezone manipulation
  var parsedDate = Date.parse(date.replace(/AM|PM/g, ''));
  return !isNaN(parsedDate) ? new Date(parsedDate) : new Date();
};

/**
 * Returns formatted date given a date and format
 * @param {string} date - string which contains date (timestamp)
 * @param {string} dateFormat - string which contains the format, by default 'EEE, MMMM d, yyyy'
 */
exports.removeTimezone = removeTimezone;
var formatDateTo = function formatDateTo(date, dateFormat) {
  var newDate = removeTimezone(date);
  var formattedDate = (0, _dateFns.format)(newDate, dateFormat);
  return formattedDate;
};

/**
 * Returns Date without taking in account primary hour & timezone, just YYYY-MM-DD
 * @param {string} date - string which contains date with or without timezone
 */
exports.formatDateTo = formatDateTo;
var removeTimeAndTimezone = function removeTimeAndTimezone(date) {
  // format YYYY-MM-DD
  var splittedDate = date.split('-');
  var newDate = new Date(parseInt(splittedDate[0]), parseInt(splittedDate[1]) - 1, parseInt(splittedDate[2]));
  return newDate;
};
exports.removeTimeAndTimezone = removeTimeAndTimezone;